export enum LinkExpirationType {
	Never = 0,
	Days = 1,
	Default = -1
}

export enum LinkAuthenticationType {
	None = 0,
	RequirePin = 100,
	Default = -1
}



// WEBPACK FOOTER //
// ./src/phoenix/domain/link.ts